import * as amplitude from '@amplitude/analytics-browser';
import {
  Experiment,
  type ExperimentClient,
  type ExperimentUser,
} from '@amplitude/experiment-js-client';
import { type RootState } from 'javascripts/store';
import { omit } from 'lodash';

type ExperimentUserData = Omit<
  RootState['user'],
  | 'highlights'
  | 'help_scout_signature'
  | 'intercom_authentication_codes'
  | 'permissions'
>;

export const ACTIVE_EXPERIMENTS = {
  ONBOARDING_CARDS: {
    key: 'web-onboarding-cards',
    variants: {
      cards_off: 'control',
      cards_on: 'treatment',
    },
  },
};

// public key
const AMPLITUDE_CLIENT_DEPLOYMENT_KEY =
  'client-81DB1WtX4Rs7TPplVPj0VxGwuHsovWlC';

class AmplitudeExperimentsManager {
  private experiment: ExperimentClient;

  constructor() {
    amplitude.init(process.env.AMPLITUDE_API_KEY, { minIdLength: 1 });
    this.experiment = Experiment.initializeWithAmplitudeAnalytics(
      AMPLITUDE_CLIENT_DEPLOYMENT_KEY,
    );
  }

  async startExperiments(cocamUser: RootState['user']): Promise<void> {
    const usableProperties = omit<ExperimentUserData>(cocamUser, [
      'highlights',
      'help_scout_signature',
      'intercom_authentication_codes',
      'permissions',
    ]);
    const user: ExperimentUser = {
      user_id: cocamUser.id.toString(),
      user_properties: {
        ...usableProperties,
      },
    };
    await this.experiment.start(user);
    await this.experiment.fetch(user);
  }

  initialize(cocamUser: RootState['user']): void {
    amplitude.setUserId(cocamUser.id.toString());
    this.startExperiments(cocamUser);
  }

  variant(flagKey: string) {
    const variant = this.experiment.variant(flagKey);
    return variant?.value;
  }
}

export default new AmplitudeExperimentsManager();
